import { useTranslation } from 'react-i18next';
import { Flex, Statistic } from 'antd';
import { useRoleGuard, UserRole } from 'shared/hooks/use-role-guard';
import { CardUi } from 'components/common/card-ui';
import { StatisticMoney } from 'components/common/statistic-money/statistic-money';
import type { IWhTaskStatisticsProps } from './types';

export const WhTaskStatistics = (props: IWhTaskStatisticsProps) => {
  const { whTask } = props;
  const { t } = useTranslation();

  const isAllowFinancialInfo = useRoleGuard([
    UserRole.admin,
    UserRole.assistant,
    UserRole.customer_manager,
    UserRole.accountant,
  ]);

  const isDone = whTask.status === 'done';

  return (
    <CardUi>
      <Flex gap='large'>
        <Statistic title={t('common:items')} value={whTask.numberOfItems} />
        <Statistic title={t('common:LDM')} value={whTask.totalLDM ?? '-'} />
        <Statistic title={t('common:weight')} suffix='kg' value={whTask.totalWeight ?? '-'} />
        <Statistic title={t('common:volume')} suffix='m³' value={whTask.totalVolume ?? '-'} />
        {whTask.daysPerItem !== null && isDone ? (
          <Statistic title={t('wh-task:days_per_item')} value={whTask.daysPerItem} />
        ) : null}
        {isAllowFinancialInfo && (
          <>
            <StatisticMoney
              title={t('order:freight')}
              currency={whTask.currency}
              value={whTask.freight}
              valueInDefault={whTask.freightInDefault}
            />
            {whTask.fineToUs && (
              <StatisticMoney
                title={t('common:fine_to_us')}
                currency={whTask.currency}
                value={whTask.fineToUs}
                valueInDefault={whTask.fineToUsInDefault}
                valueStyle={{ color: 'var(--warning)' }}
              />
            )}
            {whTask.fineByUs && (
              <StatisticMoney
                title={t('common:fine_by_us')}
                currency={whTask.currency}
                value={whTask.fineByUs}
                valueInDefault={whTask.fineByUsInDefault}
                valueStyle={{ color: 'var(--green-6)' }}
              />
            )}
          </>
        )}
      </Flex>
    </CardUi>
  );
};
